import React, {useEffect, useRef, useState} from 'react'
import {ITimespan, ITimespanProps} from '../../../utils/cellInterfaces';
import './style.css'

export const displayTimespanString = (timespan: ITimespan) => {
    var val = '';
    if (timespan.days !== undefined && timespan.days !== 0) {
        val += timespan.days + 'd ';
    }
    if (timespan.hours !== undefined && timespan.hours !== 0) {
        val += timespan.hours + 'h ';
    }
    if (timespan.minutes !== undefined && timespan.minutes !== 0) {
        val += timespan.minutes + 'm ';
    }
    if (timespan.seconds !== undefined && timespan.seconds !== 0) {
        val += timespan.seconds + 's ';
    }
    if (!val) {
        val = '-';
    }
    return val;
}

export function Timespan(props: ITimespanProps) {
    const timespan: ITimespan = props.timespan || {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    };
    // @ts-ignore
    // const divWidth = useRef(null);

    // useEffect(() => {
    //     console.log(divWidth.current);
    // }, [divWidth])

    const handleChangeEvent = (e: any, field: string) => {
        var value = e.target.value;
        if (value) {
            var val = parseInt(value);
            // @ts-ignore
            if (!isNaN(val) && val !== NaN) {
                let newobj: ITimespan = {...timespan};
                // @ts-ignore
                newobj[field] = val;
                props.changeHandler(newobj);
            }
        } else {
            let newobj: ITimespan = {...timespan};
            // @ts-ignore
            newobj[field] = 0;
            props.changeHandler(newobj);
        }
    }

    //  const displayValue = () => {
    //     var val = '';
    //     if (timespan.days !== undefined) {
    //         val += timespan.days + 'd ';
    //     }
    //     if (timespan.hours !== undefined) {
    //         val += timespan.hours + 'h ';
    //     }
    //     if (timespan.minutes !== undefined) {
    //         val += timespan.minutes + 'm ';
    //     }
    //     if (timespan.seconds !== undefined) {
    //         val += timespan.seconds + 's ';
    //     }
    //     return val;
    // }

    const timespanValuesCount = () => {
        var count = 0;
        for (const [key, value] of Object.entries(timespan)) {
            count += 1;
        }
        return count;
    }

    const divRef = useRef(null);
    const [style, setStyle] = useState({});

    const inputStyle = (inputWidth: number) => {
        return {
            width: inputWidth / timespanValuesCount() + "px",
            // border: "0px",
            padding: '0'
        }
    }

    useEffect(() => {
        if (divRef.current !== null) {
            // @ts-ignore
            var width = divRef.current.offsetWidth;
            var style = inputStyle(width);
            setStyle(style);
        }
    }, [props.isInEditMode])

    const inputStyle2 = {border: 'none', width: '100%', padding: '5px'};


    if (props.isInEditMode) {
        return <div ref={divRef} className='p-d-flex p-jc-between'>
            <div className="p-inputtext p-d-flex p-jc-between" style={style}>
                <input className="p-inputtext input" style={inputStyle2} value={timespan.days}
                       onChange={(e) => handleChangeEvent(e, 'days')}
                       inputMode='numeric'
                />
                {
                    <label style={{paddingBottom: '12px', paddingTop: '12px', paddingRight: '2px'}}>
                        d
                    </label>
                }
            </div>
            <div className="p-inputtext p-d-flex p-jc-between" style={style}>
                <input className="p-inputtext input" style={inputStyle2} value={timespan.hours}
                       onChange={(e) => handleChangeEvent(e, 'hours')}
                       inputMode='numeric'
                />
                {
                    <label style={{paddingBottom: '12px', paddingTop: '12px', paddingRight: '2px'}}>
                        h
                    </label>
                }
            </div>
            <div className="p-inputtext p-d-flex p-jc-between" style={style}>
                <input className="p-inputtext input" style={inputStyle2} value={timespan.minutes}
                       onChange={(e) => handleChangeEvent(e, 'minutes')}
                       inputMode='numeric'
                />
                {
                    <label style={{paddingBottom: '12px', paddingTop: '12px', paddingRight: '2px'}}>
                        m
                    </label>
                }
            </div>
            <div className="p-inputtext p-d-flex p-jc-between" style={style}>
                <input className="p-inputtext input" style={inputStyle2} value={timespan.seconds}
                       onChange={(e) => handleChangeEvent(e, 'seconds')}
                       inputMode='numeric'
                />
                {
                    <label style={{paddingBottom: '12px', paddingTop: '12px', paddingRight: '2px'}}>
                        s
                    </label>
                }
            </div>
        </div>
    } else {
        return <div style={{
            width: '100%',
            border: 'none',
            maxWidth: '300px',
            backgroundColor: 'transparent',
            color: "inherit",
            whiteSpace: "nowrap"
        }} className="p-inputtext">
            {/* {displayValue()} */}
            {displayTimespanString(timespan)}
        </div>
    }
}